import { NavLink, useLocation } from 'react-router'
import ROLES_MAPPING, { ROLES } from 'core/constants/roles'
import { hasPermission } from '../../../../../core/utils/hasPermission'
import FavoriteLink from './favoriteLink'
import { useContext } from 'react'
import { MenuContext } from '../menu'
import { useUserHasRoles } from 'core/hooks/useUserHasRoles'
import getRouteDisabled from './get-route-disabled'
import { useApiMenuGetUserPreferences } from '../../../../../core/api/menu/useApiMenuGetUserPreferences'
import { trackAnalyticsEvent } from '../../../../../core/hooks/useAnalytics'
import { useTranslation } from 'react-i18next'

const MenuAnimationSingleLinkContent = ({ link, isEditing, selectedView, modifiedData }) => {
  const { t } = useTranslation()
  return (
    <>
      <div className="mg-menu-animation-single-link__title">
        <span
          className={`${
            link?.navigationMenuInformation?.iconIsFilled
              ? 'material-icons notranslate'
              : 'material-icons-outlined notranslate'
          }`}
        >
          {link?.navigationMenuInformation?.iconName}
        </span>
        <span>{link?.name && t(link.name)}</span>
      </div>
      {isEditing && <FavoriteLink sublink={link} selectedView={selectedView} modifiedData={modifiedData} />}
    </>
  )
}

const MenuAnimationSingleLink = ({ link }) => {
  const actionGoogleAnalytics = `click_bottom_burger_menu_${link?.googleAnalyticsAction}`
  const isAdmin = useUserHasRoles([ROLES.ROLE_ADMIN])
  const { isEditing, selectedView, modifiedData } = useContext(MenuContext)
  const isDisabledLink = getRouteDisabled(link?.id)
  const isNavigationDisabled = isEditing || (isDisabledLink && !isAdmin)
  const activeStyle = { color: '#007DBC' }
  const { data: user } = useApiMenuGetUserPreferences()
  const urlPathname = useLocation()?.pathname

  const isActiveHoursPiloting = (path: string) => {
    return (
      path === '/piloting/hours' &&
      (urlPathname === '/piloting/hours-team' ||
        urlPathname === '/piloting/general-services' ||
        urlPathname === '/piloting/cashier-services')
    )
  }

  return (
    <>
      {hasPermission(user.roles, ROLES_MAPPING, link.rights[0]) &&
        (isNavigationDisabled ? (
          <div className={`mg-menu-animation-single-link ${isDisabledLink ? 'disabled' : ''}`}>
            <MenuAnimationSingleLinkContent
              link={link}
              isEditing={isEditing}
              selectedView={selectedView}
              modifiedData={modifiedData}
            />
          </div>
        ) : (
          <NavLink
            to={link?.path}
            className={`mg-menu-animation-single-link ${isDisabledLink ? 'disabled' : ''}`}
            onClick={() => {
              trackAnalyticsEvent(actionGoogleAnalytics)
            }}
            style={({ isActive }) => (isActive || isActiveHoursPiloting(link?.path) ? activeStyle : undefined)}
            end
          >
            <MenuAnimationSingleLinkContent
              link={link}
              isEditing={isEditing}
              selectedView={selectedView}
              modifiedData={modifiedData}
            />
          </NavLink>
        ))}
    </>
  )
}

export default MenuAnimationSingleLink
